export { default } from './TechnologiesBlock';



// WEBPACK FOOTER //
// ./src/components/TechnologiesBlock/index.js